import { Router } from '@angular/router';
import { NavigationService } from './../navigation.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  introText = 'What Type of Material?';
  numberOfClicks = 0;

  constructor(
    private nav: NavigationService,
    private router: Router
  ) {}

  ngOnInit() {
    if ( this.nav.attribution.success ) {
      this.router.navigate(['thank']);
    }
  }

  onClick(choice) {
    this.nav.updateState('choice', choice);
  }
}
